export default {
  preview: {
    label: 'Aperçu',
    tooltip: 'Prévisualiser la page de commande en ligne dans un nouvel onglet.',
  },
  buttons: {
    visit_online_store: 'Boutique en ligne',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Échec du lancement du portail de commandes',
  },
};
